const translations = {
  en: {
    nav: {
      apps: "apps",
      upcoming: "coming soon",
      about: "about",
      contact: "contact",
    },
    hero: {
      eyebrow: "mobile product studio",
      title: "apps that lighten daily life",
      subtitle:
        "wodaslabs crafts fast, friendly mobile experiences that simplify routines and deliver value quickly",
      ctaPrimary: "explore apps",
      ctaSecondary: "what's coming",
    },
    sections: {
      publishedSingleTitle: "published app",
      publishedMultipleTitle: "published apps",
      publishedMultipleDesc:
        "products you can find on the App Store and Google Play",
      upcomingTitle: "coming soon",
      upcomingDesc: "short notes on apps we are building next",
      upcomingCta: "join early access",
    },
    about: {
      title: "about wodas labs",
      p1: "we ship fast prototypes and iterate through store feedback. our goal is to help people do more with less effort on mobile",
      p2: "design, engineering, and growth sit at the same table. that gives every app a consistent tone and character",
      listTitle: "our product mindset",
      listItems: [
        "simple and clear interfaces",
        "fast setup and first value",
        "continuous micro updates",
        "high-performance architecture",
      ],
    },
    contact: {
      title: "have a new app idea?",
      desc: "reach out for partnerships, investment, or product development. we reply within 48 hours",
    },
    footer: {
      rights: "all rights reserved",
    },
    foody: {
      hero: {
        eyebrow: "foody: wellness",
        title: "turn every meal into a calm, confident choice",
        subtitle:
          "foody reads meals and barcodes in seconds, turning nutrition data into gentle, daily guidance you can trust",
        ctaPrimary: "get on the App Store",
        ctaSecondary: "find on Google Play",
      },
      meta: {
        label: "nutrition assistant",
        platform: "iOS + Android",
        tag: "smart meal scanning",
        pill: "",
        pillValue: "",
        cta: "download",
        back: "back to apps",
      },
      highlights: {
        title: "what makes foody feel easy",
        subtitle: "scan, understand, and stay consistent without overthinking",
        items: [
          {
            title: "instant food decoding",
            desc: "snap a plate or barcode to reveal ingredients, macros, and allergens in one clean view",
          },
          {
            title: "gentle daily nudges",
            desc: "micro tips help you balance meals without rigid calorie counting or noisy dashboards",
          },
          {
            title: "context-first insights",
            desc: "see how meals stack across your day with color cues and a quick progress arc",
          },
        ],
      },
      workflow: {
        title: "your 3-step routine",
        subtitle: "designed for quick check-ins between real life moments",
        steps: [
          {
            title: "scan or search",
            desc: "use the camera or barcode scanner to capture a meal in seconds",
          },
          {
            title: "review the signal",
            desc: "get nutrition highlights, ingredients, and quick notes at a glance",
          },
          {
            title: "save the moment",
            desc: "log meals and track patterns without ever leaving the flow",
          },
        ],
      },
      personas: {
        title: "made for everyday eaters",
        subtitle: "foody keeps the tone light while you stay on track",
        items: ["busy professionals", "wellness starters", "gym regulars"],
        note: "no macros obsession, just clarity and progress you can feel daily.",
      },
      cta: {
        title: "ready for a calmer nutrition routine?",
        desc: "foody keeps food decisions lightweight and reassuring, one scan at a time.",
        primary: "open App Store",
        secondary: "open Google Play",
      },
    },
    foodyPrivacy: {
      nav: {
        back: "back to app",
        privacy: "privacy",
        cookie: "cookie",
        terms: "terms",
        delete: "delete",
      },
      badge: "privacy policy",
      hero: {
        title: "Foody App Privacy Policy",
        desc: 'This privacy policy applies to the Foody app for mobile devices, developed by Wodas Labs as a freemium service and provided on an "AS IS" basis.',
        effectiveDate: "Effective date: December 27, 2025",
      },
      provided: {
        title: "What information do users provide?",
        p1: "The Application acquires information when you download and register the app. Registration is not mandatory, but some features may require it.",
        p2: "The Service Provider may use your information to send important notices, required information, and marketing promotions.",
      },
      automatic: {
        title: "What information is collected automatically?",
        desc: "The Application may automatically collect device type, unique device ID, IP address, operating system, browser type, and app usage details.",
      },
      location: {
        title: "Precise location data",
        desc: "The Application does not gather precise real-time location information of your device.",
      },
      ai: {
        title: "Artificial Intelligence (AI) usage",
        desc: "The Application uses AI technologies to enhance user experience and provide certain features, such as:",
        items: [
          "Personalized content based on usage patterns",
          "Feature or content recommendations from in-app interactions",
          "Automated functionalities for efficiency",
          "AI processing aligned with this policy and applicable laws",
        ],
      },
      thirdParty: {
        title: "Third-party access",
        p1: "Only aggregated, anonymized data is periodically transmitted to external services to improve the Application and service quality.",
        p2: "Third-party service providers used by the Application:",
        providers: [
          {
            name: "Google Play Services",
            url: "https://www.google.com/policies/privacy/",
          },
          {
            name: "AdMob",
            url: "https://support.google.com/admob/answer/6128543?hl=en",
          },
          {
            name: "RevenueCat",
            url: "https://www.revenuecat.com/privacy",
          },
        ],
        p3: "The Service Provider may disclose user information in the following cases:",
        disclosures: [
          "When required by law or legal process",
          "To protect rights, safety, investigate fraud, or respond to government requests",
          "With trusted service providers under confidentiality obligations",
        ],
      },
      optOut: {
        title: "Opt-out rights",
        desc: "You can stop all information collection by uninstalling the Application using standard device or app marketplace uninstall methods.",
      },
      retention: {
        title: "Data retention and management",
        desc: "User-provided data is retained while you use the app and for a reasonable time after. Automatically collected data may be retained up to 24 months and then stored in aggregate. For deletion requests, contact support-foody@wodaslabs.com.",
      },
      children: {
        title: "Children's privacy",
        p1: "The Service Provider does not knowingly solicit data from or market to children under 13.",
        p2: "If a child under 13 has provided personal information, it will be deleted promptly. Parents or guardians can contact support-foody@wodaslabs.com.",
      },
      security: {
        title: "Information security",
        desc: "The Service Provider applies physical, electronic, and procedural safeguards to protect processed and stored information.",
      },
      changes: {
        title: "Policy changes",
        desc: "This Privacy Policy may be updated from time to time. Continued use of the Application is considered acceptance of all changes.",
      },
      consent: {
        title: "Your consent",
        desc: "By using the Application, you consent to processing of your information as described in this Privacy Policy.",
      },
      contact: {
        title: "How can you contact us?",
        desc: "If you have questions regarding privacy while using the Application, please contact:",
      },
    },
    foodyCookie: {
      nav: {
        back: "back to app",
        privacy: "privacy",
        cookie: "cookie",
        terms: "terms",
        delete: "delete",
      },
      badge: "cookie policy",
      hero: {
        title: "Foody App Cookie Policy",
        desc: 'This Cookie Policy explains how Wodas Labs ("Service Provider") uses cookies and similar technologies in relation to the Foody app and associated website(s).',
      },
      mobile: {
        title: "Do we use cookies in the mobile app?",
        desc: "The Application itself does not use browser cookies. However, it may use local storage or device identifiers for essential functionality such as authentication and session management.",
      },
      website: {
        title: "Cookies on our website",
        desc: "Our website may use cookies to ensure the site works properly, remember preferences, and understand usage. These may include:",
        cookies: [
          "Essential cookies needed for basic site functionality.",
          "Preference cookies to remember your settings.",
          "Analytics cookies to help us improve the site.",
        ],
      },
      thirdParty: {
        title: "Third-party services",
        desc: "We may use third-party services that set cookies or similar technologies to provide analytics or other features. These providers may collect information about your activity on our website.",
      },
      manage: {
        title: "Managing cookies",
        desc: "You can manage or disable cookies in your browser settings. If disabled, some website features may not function properly.",
      },
      contact: {
        title: "Contact",
        desc: "If you have questions about this Cookie Policy, contact us at:",
      },
    },
    foodyTerms: {
      nav: {
        back: "back to app",
        privacy: "privacy",
        cookie: "cookie",
        terms: "terms",
        delete: "delete",
      },
      badge: "terms & conditions",
      hero: {
        title: "Foody App Terms & Conditions",
        desc: "These terms and conditions apply to the Foody app for mobile devices, created by Wodas Labs as a freemium service.",
        effectiveDate: "Effective date: December 27, 2025",
      },
      acceptance: {
        title: "Acceptance of terms",
        p1: "By downloading or using the Application, you automatically agree to these terms. Please read and understand them before use.",
        p2: "Unauthorized copying, modification, reverse engineering, translation, or creating derivative versions of the Application is prohibited.",
      },
      intellectualProperty: {
        title: "Intellectual property",
        desc: "All trademarks, copyrights, database rights, and related intellectual property rights remain the property of the Service Provider.",
      },
      serviceChanges: {
        title: "Service changes and charges",
        desc: "The Service Provider may modify the Application or introduce charges at any time. Any applicable charges will be clearly communicated.",
      },
      deviceSecurity: {
        title: "Device security responsibility",
        desc: "You are responsible for maintaining your phone security and access. Jailbreaking or rooting may expose your device to risks and cause the app to malfunction.",
      },
      thirdParty: {
        title: "Third-party terms",
        desc: "The Application uses third-party services that have their own Terms and Conditions:",
        providers: [
          {
            name: "Google Play Services",
            url: "https://policies.google.com/terms",
          },
          {
            name: "AdMob",
            url: "https://developers.google.com/admob/terms",
          },
          {
            name: "RevenueCat",
            url: "https://www.revenuecat.com/terms",
          },
        ],
      },
      connectivity: {
        title: "Connectivity and charges",
        p1: "Some app functions require an active internet connection. The Service Provider is not responsible for reduced functionality due to lack of Wi-Fi or exhausted data allowance.",
        p2: "If used outside Wi-Fi, mobile provider terms and charges may apply, including roaming charges.",
      },
      liability: {
        title: "Liability limitations",
        p1: "You are responsible for practical usage conditions, such as keeping your device charged to access the Service.",
        p2: "The Service Provider is not liable for direct or indirect loss resulting from reliance on the Application functionality.",
      },
      ai: {
        title: "AI technologies",
        desc: "The Application may incorporate AI technologies for certain features. By using the app, you acknowledge this and agree that AI usage complies with applicable laws.",
      },
      updates: {
        title: "Updates and termination",
        desc: "The Application may be updated, changed, or discontinued at any time. If service is terminated, your rights to use the Application end and you must stop using it.",
      },
      changes: {
        title: "Changes to terms",
        desc: "The Service Provider may update these Terms and Conditions periodically. Please review this page regularly.",
      },
      contact: {
        title: "Contact us",
        desc: "If you have questions or suggestions about these Terms and Conditions, please contact:",
      },
    },
    foodyDelete: {
      nav: {
        back: "back to app",
        privacy: "privacy",
        cookie: "cookie",
        terms: "terms",
        delete: "delete",
      },
      badge: "account deletion",
      hero: {
        title: "Account deletion",
        desc: "You can delete your Foody account and associated data at any time.",
      },
      inApp: {
        title: "Option 1 (recommended): Delete from the app",
        desc: "Open the Foody app and go to Profile -> Delete account. Follow the confirmation steps.",
      },
      request: {
        title: "Option 2: Request deletion via email",
        desc: 'Send an email to support-foody@wodaslabs.com with the subject "Foody Account Deletion Request" and include:',
        items: ["The email address you used to sign in"],
        footer: "We will process deletion requests as soon as possible.",
      },
      contact: {
        title: "Deletion request email",
        desc: "Use this email and subject line for deletion requests:",
      },
    },
    foodySupport: {
      badge: "support",
      back: "back to app",
      hero: {
        title: "Foody Support",
        descPrefix: "need help with",
        descSuffix:
          "we are here to help with account, nutrition, purchase, and app-related issues.",
        updatedAt: "Last updated: March 31, 2026",
      },
      contact: {
        title: "contact",
        emailLabel: "email support:",
        responseTime: "response time target: within 2 business days.",
      },
      contactDetails: {
        title: "when you contact us",
        subtitle: "include these details to speed up support:",
        details: [
          "App version (example: 1.0.2)",
          "Device model and OS version",
          "Short description of the issue",
          "Screenshots or screen recording (if possible)",
        ],
      },
      commonIssues: {
        title: "common issues",
        items: [
          "Close and reopen the app.",
          "Check your internet connection.",
          "Update to the latest app version from the store.",
          "Restart your device.",
        ],
      },
      links: {
        title: "links",
        home: "WodasLabs",
        privacy: "Privacy Policy",
        terms: "Terms & Conditions",
        cookie: "Cookie Policy",
        delete: "Delete Account",
      },
      footer: {
        title: "need direct help?",
        desc: "For legal or privacy inquiries, contact:",
        emailButton: "Email Support",
      },
    },
    trains: {
      hero: {
        eyebrow: "trains escape",
        title: "guide trains in the right order and clear every level",
        subtitle:
          "tap a train and it moves forward in its locomotive direction. if another train blocks the path, it cannot exit.",
        ctaPrimary: "get on the App Store",
        ctaSecondary: "find on Google Play",
      },
      meta: {
        label: "logic train puzzle",
        platform: "iOS + Android",
        tag: "order + strategy",
        pill: "",
        pillValue: "",
        cta: "download",
        back: "back to apps",
      },
      highlights: {
        title: "why trains escape stands out",
        subtitle: "easy one-tap controls with smart puzzle depth",
        items: [
          {
            title: "one-tap directional movement",
            desc: "tap any train to slide it out of the board in the direction it faces.",
          },
          {
            title: "blocker-aware puzzles",
            desc: "a train cannot leave if another train is in front, so every move depends on sequence.",
          },
          {
            title: "clean and smooth design",
            desc: "minimal visuals keep focus on logic, route reading, and calm problem-solving.",
          },
        ],
      },
      workflow: {
        title: "how each level works",
        subtitle: "clear all trains from the screen to complete the puzzle",
        steps: [
          {
            title: "read the board",
            desc: "check train directions and spot which ones are currently blocked.",
          },
          {
            title: "choose the right order",
            desc: "remove free trains first to open space for blocked ones.",
          },
          {
            title: "finish the level",
            desc: "when every train exits the screen safely, the level is completed.",
          },
        ],
      },
      personas: {
        title: "made for puzzle lovers",
        subtitle: "relaxing flow with strategic thinking",
        items: [
          "logic puzzle players",
          "quick break gamers",
          "strategy and planning fans",
        ],
        note: "dynamic layouts and increasing challenge keep every level fresh.",
      },
      cta: {
        title: "can you clear all trains safely?",
        desc: "take control of the rails, prevent crashes, and solve smarter levels.",
        primary: "open App Store",
        secondary: "open Google Play",
      },
    },
    trainsSupport: {
      badge: "support",
      back: "back to app",
      hero: {
        title: "Trains Escape Support",
        descPrefix: "need help with",
        descSuffix:
          "we are here to help with gameplay issues, bugs, purchase problems, and account/device-related questions.",
        updatedAt: "Last updated: March 29, 2026",
      },
      contact: {
        title: "contact",
        emailLabel: "email support:",
        responseTime: "response time target: within 2 business days.",
      },
      contactDetails: {
        title: "when you contact us",
        subtitle: "include these details to speed up support:",
        details: [
          "App version (example: 1.0.2)",
          "Device model and iOS version",
          "Short description of the problem",
          "Screenshots or screen recording (if possible)",
        ],
      },
      commonIssues: {
        title: "common issues",
        items: [
          "Close and reopen the app.",
          "Check your internet connection.",
          "Update to the latest app version from the App Store.",
          "Restart your device.",
        ],
      },
      links: {
        title: "links",
        home: "WodasLabs",
        privacy: "Privacy Policy",
        terms: "Terms & Conditions",
      },
      footer: {
        title: "need direct help?",
        desc: "For legal or privacy inquiries, contact:",
        emailButton: "Email Support",
      },
    },
    trainsPrivacy: {
      nav: {
        back: "back to app",
        support: "support",
        terms: "terms",
      },
      badge: "privacy policy",
      hero: {
        title: "Trains Escape Privacy Policy",
        desc: 'This privacy policy applies to the Trains Escape app for mobile devices, created by Wodas Labs as a freemium service and provided on an "AS IS" basis.',
        effectiveDate: "Effective date: March 15, 2026",
      },
      collection: {
        title: "Information Collection and Use",
        desc: "The Application collects information when you download and use it. This may include:",
        items: [
          "Your device's Internet Protocol address (e.g. IP address)",
          "The pages you visit, the time/date of your visit, and time spent on those pages",
          "The total time spent on the Application",
          "The operating system on your mobile device",
        ],
        noLocation:
          "The Application does not gather precise information about your device location.",
        noAi: "The Application does not use Artificial Intelligence (AI) technologies to process your data or provide features.",
      },
      personal: {
        title: "Personal Data and Communications",
        p1: "For a better experience, the Service Provider may request personally identifiable information, including device information, advertising identifier, and purchase information.",
        p2: "The Service Provider may use provided information for important notices, required information, and marketing promotions.",
      },
      thirdParty: {
        title: "Third Party Access",
        p1: "Only aggregated, anonymized data may be transmitted periodically to external services to improve the Application and service quality.",
        p2: "Third-party services used by the Application:",
        providers: [
          {
            name: "Google Play Services",
            url: "https://www.google.com/policies/privacy/",
          },
          {
            name: "AdMob",
            url: "https://support.google.com/admob/answer/6128543?hl=en",
          },
          {
            name: "RevenueCat",
            url: "https://www.revenuecat.com/privacy",
          },
        ],
      },
      disclosure: {
        title: "Disclosure Cases",
        desc: "The Service Provider may disclose information when required by law, to protect rights and safety, investigate fraud, or when working with trusted service providers under confidentiality obligations.",
      },
      optOut: {
        title: "Opt-Out Rights",
        desc: "You can stop all data collection by uninstalling the Application through standard device or app marketplace uninstall processes.",
      },
      retention: {
        title: "Data Retention",
        desc: "User-provided data is retained while you use the Application and for a reasonable time afterwards.",
        contactLabel: "For deletion requests, contact:",
      },
      children: {
        title: "Children",
        p1: "The Application is not intended to knowingly collect personal information from children under 13.",
        p2: "If such data is identified, it will be deleted promptly. Parents or guardians can contact the Service Provider at support-trainsescape@wodaslabs.com.",
      },
      security: {
        title: "Security and Changes",
        p1: "The Service Provider applies physical, electronic, and procedural safeguards for data it processes and maintains.",
        p2: "This policy may be updated. Continued use of the Application is considered acceptance of updated terms.",
      },
      contact: {
        title: "Contact Us",
        desc: "If you have privacy questions while using the Application, please contact:",
        cta: "open support",
      },
    },
    trainsTerms: {
      nav: {
        back: "back to app",
        support: "support",
      },
      badge: "terms & conditions",
      hero: {
        title: "Trains Escape Terms & Conditions",
        desc: "These terms apply to the Trains Escape mobile application provided by Wodas Labs as a freemium service.",
        effectiveDate: "Effective date: March 15, 2026",
      },
      acceptance: {
        title: "Acceptance of Terms",
        p1: "By downloading or using the Application, you automatically agree to these terms. Please read them carefully before use.",
        p2: "Unauthorized copying, modification, reverse engineering, translation, or derivative versions of the Application are not permitted.",
      },
      intellectualProperty: {
        title: "Intellectual Property",
        desc: "All trademarks, copyrights, database rights, and other intellectual property rights related to the Application remain the property of the Service Provider.",
      },
      serviceChanges: {
        title: "Service Changes and Charges",
        desc: "The Service Provider may modify the Application or introduce charges at any time. Any charges will be clearly communicated.",
      },
      deviceSecurity: {
        title: "Device Security Responsibility",
        desc: "You are responsible for keeping your device secure. Jailbreaking or rooting may expose your device to security risks and may cause the Application to malfunction.",
      },
      thirdParty: {
        title: "Third-Party Terms",
        desc: "The Application uses third-party services that have their own terms and conditions:",
        providers: [
          {
            name: "Google Play Services",
            url: "https://policies.google.com/terms",
          },
          {
            name: "AdMob",
            url: "https://developers.google.com/admob/terms",
          },
          {
            name: "RevenueCat",
            url: "https://www.revenuecat.com/terms",
          },
        ],
      },
      connectivity: {
        title: "Connectivity and Data Charges",
        p1: "Some functionality requires an active internet connection. The Service Provider is not responsible for limited functionality caused by connection issues or exhausted data limits.",
        p2: "If used outside Wi-Fi, your mobile provider terms and charges (including roaming charges) may apply.",
      },
      liability: {
        title: "Liability Limitations",
        p1: "The Service Provider cannot always assume responsibility for your device state (such as battery level) or uninterrupted access to the service.",
        p2: "The Service Provider is not liable for direct or indirect losses resulting from reliance on Application functionality.",
      },
      updates: {
        title: "Updates and Termination",
        desc: "The Application may be updated, changed, or discontinued at any time. If the service is terminated, your rights to use the Application end and you must stop using it.",
      },
      changes: {
        title: "Changes to Terms",
        desc: "The Service Provider may update these terms periodically. Please review this page regularly for updates.",
      },
      contact: {
        title: "Contact Us",
        desc: "If you have questions or suggestions about these Terms and Conditions, please contact:",
        cta: "open support",
      },
    },
    orbis: {
      hero: {
        eyebrow: "Orbis Lines",
        title: "build color lines and keep the 9x9 board alive",
        subtitle:
          "move balls across the board, create lines of 5 or more matching colors, and plan enough empty space for the next spawn.",
        ctaPrimary: "get on the App Store",
        ctaSecondary: "find on Google Play",
      },
      meta: {
        label: "classic lines puzzle",
        platform: "iOS + Android",
        tag: "color strategy",
        pill: "",
        pillValue: "",
        cta: "download",
        back: "back to apps",
      },
      highlights: {
        title: "classic lines strategy on mobile",
        subtitle: "simple moves, sharp path planning, and fast scoring decisions",
        items: [
          {
            title: "9x9 board tactics",
            desc: "move balls into position while preserving open routes for future turns.",
          },
          {
            title: "path-based movement",
            desc: "a ball can move only when there is a free path from its current cell to the target cell.",
          },
          {
            title: "horizontal, vertical, diagonal clears",
            desc: "create lines in any direction and remove matching balls before the board fills up.",
          },
        ],
      },
      workflow: {
        title: "how to play",
        subtitle:
          "clear lines of 5 or more same-color balls before the board runs out of space",
        steps: [
          {
            title: "choose a ball",
            desc: "select a ball and move it to an empty cell if a free path exists.",
          },
          {
            title: "form a line",
            desc: "line up 5 or more balls of the same color horizontally, vertically, or diagonally.",
          },
          {
            title: "manage new spawns",
            desc: "after each move, if no line is cleared, new balls appear on the board.",
          },
          {
            title: "survive the full board",
            desc: "the game ends when the board is full and no more moves can be made.",
          },
        ],
      },
      scoring: {
        title: "scoring",
        subtitle: "clear more balls and directions for bigger scores",
        items: [
          "5 balls = 5 points",
          "6 balls = 6 points, and so on",
          "2 directions in one move = x2",
          "3 directions in one move = x3",
          "4 directions in one move = x5",
        ],
        note: "best scores are stored anonymously so players can keep track of their progress.",
      },
      cta: {
        title: "ready to keep the board open?",
        desc: "make clean moves, chain strong clears, and chase a higher best score.",
        primary: "open App Store",
        secondary: "open Google Play",
      },
    },
    orbisSupport: {
      badge: "support",
      back: "back to app",
      hero: {
        title: "Orbis Lines Support",
        descPrefix: "need help with",
        descSuffix:
          "we are here to help with gameplay issues, bugs, ads, scores, and device-related questions.",
        updatedAt: "Last updated: May 2, 2026",
      },
      contact: {
        title: "contact",
        emailLabel: "email support:",
        responseTime: "response time target: within 2 business days.",
      },
      contactDetails: {
        title: "when you contact us",
        subtitle: "include these details to speed up support:",
        details: [
          "App version (example: 1.0.0)",
          "Device model and OS version",
          "Short description of the problem",
          "Screenshots or screen recording (if possible)",
        ],
      },
      commonIssues: {
        title: "common issues",
        items: [
          "Close and reopen the app.",
          "Check your internet connection.",
          "Update to the latest app version from the store.",
          "Restart your device.",
        ],
      },
      links: {
        title: "links",
        home: "WodasLabs",
        privacy: "Privacy Policy",
        terms: "Terms & Conditions",
      },
      footer: {
        title: "need direct help?",
        desc: "For legal or privacy inquiries, contact:",
        emailButton: "Email Support",
      },
    },
    orbisPrivacy: {
      nav: {
        back: "back to app",
        support: "support",
        terms: "terms",
      },
      badge: "privacy policy",
      hero: {
        title: "Orbis Lines Privacy Policy",
        desc: 'This privacy policy applies to the Orbis Lines app for mobile devices, created by Wodas Labs as a freemium service and provided on an "AS IS" basis.',
        effectiveDate: "Effective date: May 2, 2026",
      },
      collection: {
        title: "Information Collection and Use",
        desc: "The Application may collect limited technical and gameplay information when you download and use it. This may include:",
        items: [
          "Anonymous best score and gameplay progress needed for score features",
          "App configuration values from Firebase, such as force update, ad configuration, and feature settings",
          "Device type, operating system version, app version, and basic diagnostics",
          "Advertising-related signals if ads are shown in the Application",
        ],
        noPersonal:
          "The Application does not require an account and does not intentionally store names, email addresses, phone numbers, or other directly identifying personal information for score features.",
        noLocation:
          "The Application does not gather precise information about your device location.",
        noAi: "The Application does not use Artificial Intelligence (AI) technologies to process your data or provide features.",
      },
      firebase: {
        title: "Firebase and Anonymous Scores",
        p1: "Orbis Lines uses Firebase to store anonymous best scores and app configuration values. These records are used to keep score features working, support force update flows, and manage app or advertising settings.",
        p2: "Best score data is not tied to a personal profile. We may use anonymous or generated identifiers only when needed to save or retrieve game-related records.",
      },
      thirdParty: {
        title: "Third Party Access",
        p1: "Only limited, aggregated, or anonymous data may be transmitted to external services to operate, secure, and improve the Application.",
        p2: "Third-party services used by the Application may include:",
        providers: [
          {
            name: "Google Play Services",
            url: "https://www.google.com/policies/privacy/",
          },
          {
            name: "Firebase",
            url: "https://firebase.google.com/support/privacy",
          },
          {
            name: "AdMob",
            url: "https://support.google.com/admob/answer/6128543?hl=en",
          },
        ],
      },
      disclosure: {
        title: "Disclosure Cases",
        desc: "The Service Provider may disclose information when required by law, to protect rights and safety, investigate fraud or abuse, or when working with trusted service providers under confidentiality obligations.",
      },
      optOut: {
        title: "Opt-Out Rights",
        desc: "You can stop all data collection by uninstalling the Application through standard device or app marketplace uninstall processes.",
      },
      retention: {
        title: "Data Retention",
        desc: "Anonymous score and configuration-related records are retained while needed to provide and improve the Application. Aggregated diagnostics may be retained for service quality and fraud prevention.",
        contactLabel: "For deletion or privacy requests, contact:",
      },
      children: {
        title: "Children",
        p1: "The Application is not intended to knowingly collect personal information from children under 13.",
        p2: "If such data is identified, it will be deleted promptly. Parents or guardians can contact the Service Provider at support-orbislines@wodaslabs.com.",
      },
      security: {
        title: "Security and Changes",
        p1: "The Service Provider applies physical, electronic, and procedural safeguards for data it processes and maintains.",
        p2: "This policy may be updated. Continued use of the Application is considered acceptance of updated terms.",
      },
      contact: {
        title: "Contact Us",
        desc: "If you have privacy questions while using the Application, please contact:",
        cta: "open support",
      },
    },
    orbisTerms: {
      nav: {
        back: "back to app",
        support: "support",
      },
      badge: "terms & conditions",
      hero: {
        title: "Orbis Lines Terms & Conditions",
        desc: "These terms apply to the Orbis Lines mobile application provided by Wodas Labs as a freemium service.",
        effectiveDate: "Effective date: May 2, 2026",
      },
      acceptance: {
        title: "Acceptance of Terms",
        p1: "By downloading or using the Application, you automatically agree to these terms. Please read them carefully before use.",
        p2: "Unauthorized copying, modification, reverse engineering, translation, or derivative versions of the Application are not permitted.",
      },
      gameplay: {
        title: "Gameplay and Scores",
        desc: "Orbis Lines is provided for entertainment. Scores, best scores, ad availability, force update behavior, and game configuration may depend on local device state or remote configuration services.",
      },
      intellectualProperty: {
        title: "Intellectual Property",
        desc: "All trademarks, copyrights, database rights, and other intellectual property rights related to the Application remain the property of the Service Provider.",
      },
      serviceChanges: {
        title: "Service Changes and Charges",
        desc: "The Service Provider may modify the Application, adjust app configuration, change ad behavior, or introduce charges at any time. Any charges will be clearly communicated.",
      },
      deviceSecurity: {
        title: "Device Security Responsibility",
        desc: "You are responsible for keeping your device secure. Jailbreaking or rooting may expose your device to security risks and may cause the Application to malfunction.",
      },
      thirdParty: {
        title: "Third-Party Terms",
        desc: "The Application uses third-party services that have their own terms and conditions:",
        providers: [
          {
            name: "Google Play Services",
            url: "https://policies.google.com/terms",
          },
          {
            name: "Firebase",
            url: "https://firebase.google.com/terms",
          },
          {
            name: "AdMob",
            url: "https://developers.google.com/admob/terms",
          },
        ],
      },
      connectivity: {
        title: "Connectivity and Data Charges",
        p1: "Some functionality may require an active internet connection, including remote configuration, ads, force update checks, diagnostics, and score-related features.",
        p2: "If used outside Wi-Fi, your mobile provider terms and charges (including roaming charges) may apply.",
      },
      liability: {
        title: "Liability Limitations",
        p1: "The Service Provider cannot always assume responsibility for your device state, network connection, interrupted access, score sync issues, or third-party service availability.",
        p2: "The Service Provider is not liable for direct or indirect losses resulting from reliance on Application functionality.",
      },
      updates: {
        title: "Updates and Termination",
        desc: "The Application may be updated, changed, force-updated, or discontinued at any time. If the service is terminated, your rights to use the Application end and you must stop using it.",
      },
      changes: {
        title: "Changes to Terms",
        desc: "The Service Provider may update these terms periodically. Please review this page regularly for updates.",
      },
      contact: {
        title: "Contact Us",
        desc: "If you have questions or suggestions about these Terms and Conditions, please contact:",
        cta: "open support",
      },
    },
  },
  tr: {
    nav: {
      apps: "uygulamalar",
      upcoming: "yakında",
      about: "hakkımızda",
      contact: "iletişim",
    },
    hero: {
      eyebrow: "mobil ürün stüdyosu",
      title: "mobil hayatı hafifleten uygulamalar",
      subtitle:
        "wodaslabs, gündelik rutinleri sade, hızlı ve keyifli hale getiren mobil deneyimler tasarlar",
      ctaPrimary: "uygulamaları keşfet",
      ctaSecondary: "yakında ne var",
    },
    sections: {
      publishedSingleTitle: "yayındaki uygulamamız",
      publishedMultipleTitle: "yayındaki uygulamalar",
      publishedMultipleDesc:
        "App Store ve Google Play üzerinden erişebileceğiniz ürünler",
      upcomingTitle: "yakında",
      upcomingDesc: "üzerinde çalıstığımız yeni uygulamaların kısa notları",
      upcomingCta: "erken erişim listesi",
    },
    about: {
      title: "wodaslabs hakkında",
      p1: "küçük ekiplerle hızlı prototipler çıkartıyor, app store geribildirimleriyle ürünleri sürekli yeniliyoruz",
      p2: "tasarım, yazılım ve büyüme ekiplerimiz tek bir masa etrafında çalışır. bu sayede her uygulama tek bir tonu ve karakteri taşır",
      listTitle: "ürün felsefemiz",
      listItems: [
        "basit ve net arayüzler",
        "hızlı kurulum ve ilk değer",
        "devamlı mikro güncellemeler",
        "yüksek performanslı mimari",
      ],
    },
    contact: {
      title: "yeni bir uygulama fikri mi var?",
      desc: "iş ortaklığı, yatırım veya ürün geliştirme için bize yazın. en geç 48 saat içinde geri döneriz",
    },
    footer: {
      rights: "tüm hakları saklıdır",
    },
    foody: {
      hero: {
        eyebrow: "foody: wellness",
        title: "her öğünde sakin ve net seçimler",
        subtitle:
          "foody, yemek ve barkodları saniyeler içinde okur; beslenme bilgisini sade, güven veren bir rehbere dönüştürür",
        ctaPrimary: "App Store'da aç",
        ctaSecondary: "Google Play'de bul",
      },
      meta: {
        label: "beslenme asistanı",
        platform: "Android",
        tag: "akıllı yemek tarama",
        pill: "",
        pillValue: "",
        cta: "indir",
        back: "uygulamalara dön",
      },
      highlights: {
        title: "foody'yi kolay hissettiren detaylar",
        subtitle: "tara, anla ve günlük dengeyi zorlamadan koru",
        items: [
          {
            title: "anında gıda okuma",
            desc: "tabak ya da barkod çekerek içerik, makro ve alerjenleri tek ekranda gör",
          },
          {
            title: "nazik günlük yönlendirme",
            desc: "küçük ipuçlarıyla kalori takıntısı olmadan dengeli kal",
          },
          {
            title: "bağlam odaklı içgörü",
            desc: "öğünlerin gün içindeki toplam etkisini renk ve özetlerle takip et",
          },
        ],
      },
      workflow: {
        title: "3 adımda günlük akış",
        subtitle: "gerçek hayatın arasında hızlı kontrol için tasarlandı",
        steps: [
          {
            title: "tara ya da ara",
            desc: "kamera veya barkod ile öğünü saniyeler içinde yakala",
          },
          {
            title: "sinyali gör",
            desc: "besin değerleri ve öne çıkan notları tek bakışta incele",
          },
          {
            title: "anı kaydet",
            desc: "öğünlerini sakla ve ritmini bozmadan takip et",
          },
        ],
      },
      personas: {
        title: "her günün tüketicisi için",
        subtitle: "foody tonu hafif tutarken sen yolda kalırsın",
        items: [
          "yoğun çalışanlar",
          "wellness'a yeni başlayanlar",
          "spor yapanlar",
        ],
        note: "makro takıntısı yok, sadece günlük netlik ve ilerleme.",
      },
      cta: {
        title: "daha sakin bir beslenme rutini hazır mı?",
        desc: "foody, her taramada hafif ve güven veren bir yol açar.",
        primary: "App Store'a git",
        secondary: "Google Play'e git",
      },
    },
    foodyPrivacy: {
      nav: {
        back: "uygulamaya dön",
        privacy: "gizlilik",
        cookie: "çerez",
        terms: "koşullar",
        delete: "silme",
      },
      badge: "gizlilik politikası",
      hero: {
        title: "Foody Uygulaması Gizlilik Politikası",
        desc: 'Bu gizlilik politikası, Wodas Labs tarafından freemium hizmet olarak sunulan Foody mobil uygulaması için geçerlidir ve hizmet "OLDUĞU GİBİ" sağlanır.',
        effectiveDate: "Yürürlük tarihi: 27 Aralık 2025",
      },
      provided: {
        title: "Kullanıcılar hangi bilgileri sağlar?",
        p1: "Uygulama, uygulamayı indirdiğinizde ve kayıt olduğunuzda bazı bilgileri alır. Kayıt zorunlu değildir ancak bazı özellikler için gerekli olabilir.",
        p2: "Hizmet Sağlayıcı, sağladığınız bilgileri önemli bildirimler, zorunlu duyurular ve pazarlama amaçlı iletişim için kullanabilir.",
      },
      automatic: {
        title: "Hangi bilgiler otomatik toplanır?",
        desc: "Uygulama; cihaz tipi, benzersiz cihaz kimliği, IP adresi, işletim sistemi, tarayıcı tipi ve kullanım bilgileri gibi verileri otomatik toplayabilir.",
      },
      location: {
        title: "Hassas konum verisi",
        desc: "Uygulama, cihazınızın hassas gerçek zamanlı konum bilgisini toplamaz.",
      },
      ai: {
        title: "Yapay Zeka (AI) kullanımı",
        desc: "Uygulama, kullanıcı deneyimini geliştirmek ve bazı özellikleri sunmak için AI teknolojileri kullanır. Örnekler:",
        items: [
          "Kullanım alışkanlıklarına göre kişiselleştirilmiş içerik",
          "Uygulama içi etkileşimlere göre öneriler",
          "Verimlilik için otomatik işlevler",
          "AI işlemlerinin politika ve yasalara uygun şekilde yürütülmesi",
        ],
      },
      thirdParty: {
        title: "Üçüncü taraf erişimi",
        p1: "Yalnızca toplu ve anonimleştirilmiş veriler, Uygulamayı ve hizmet kalitesini geliştirmek için belirli aralıklarla dış servislere aktarılır.",
        p2: "Uygulamanın kullandığı üçüncü taraf hizmet sağlayıcıları:",
        providers: [
          {
            name: "Google Play Services",
            url: "https://www.google.com/policies/privacy/",
          },
          {
            name: "AdMob",
            url: "https://support.google.com/admob/answer/6128543?hl=en",
          },
          {
            name: "RevenueCat",
            url: "https://www.revenuecat.com/privacy",
          },
        ],
        p3: "Hizmet Sağlayıcı aşağıdaki durumlarda bilgi paylaşabilir:",
        disclosures: [
          "Yasal zorunluluk veya benzeri hukuki süreçlerde",
          "Hakların ve güvenliğin korunması, dolandırıcılığın araştırılması veya resmi taleplere yanıt verilmesi için",
          "Gizlilik yükümlülüğü altındaki güvenilir hizmet sağlayıcılarla",
        ],
      },
      optOut: {
        title: "Vazgeçme hakları",
        desc: "Bilgi toplanmasını durdurmak için uygulamayı cihazınızdan veya uygulama mağazasından standart yöntemlerle kaldırabilirsiniz.",
      },
      retention: {
        title: "Veri saklama ve yönetimi",
        desc: "Kullanıcı tarafından sağlanan veriler, uygulamayı kullandığınız süre boyunca ve sonrasında makul bir süre saklanır. Otomatik toplanan veriler 24 aya kadar saklanabilir ve sonrasında toplu olarak tutulabilir. Veri silme talepleri için support-foody@wodaslabs.com adresine yazabilirsiniz.",
      },
      children: {
        title: "Çocukların gizliliği",
        p1: "Hizmet Sağlayıcı, 13 yaş altındaki çocuklardan bilerek veri toplamayı veya pazarlamayı hedeflemez.",
        p2: "13 yaş altı bir çocuğun kişisel veri sağladığı tespit edilirse veriler hızla silinir. Ebeveynler veya vasiler support-foody@wodaslabs.com adresinden iletişime geçebilir.",
      },
      security: {
        title: "Bilgilerin güvenliği",
        desc: "Hizmet Sağlayıcı, işlenen ve saklanan bilgileri korumak için fiziksel, elektronik ve prosedürel güvenlik önlemleri uygular.",
      },
      changes: {
        title: "Politika değişiklikleri",
        desc: "Bu Gizlilik Politikası zaman zaman güncellenebilir. Uygulamayı kullanmaya devam etmeniz tüm değişiklikleri kabul ettiğiniz anlamına gelir.",
      },
      consent: {
        title: "Onayınız",
        desc: "Uygulamayı kullanarak, bilgilerinizin bu Gizlilik Politikasında açıklandığı şekilde işlenmesine onay vermiş olursunuz.",
      },
      contact: {
        title: "Bize nasıl ulaşabilirsiniz?",
        desc: "Uygulamayı kullanırken gizlilikle ilgili sorularınız varsa lütfen şu adrese yazın:",
      },
    },
    foodyCookie: {
      nav: {
        back: "uygulamaya dön",
        privacy: "gizlilik",
        cookie: "çerez",
        terms: "koşullar",
        delete: "silme",
      },
      badge: "çerez politikası",
      hero: {
        title: "Foody Uygulaması Çerez Politikası",
        desc: 'Bu Çerez Politikası, Wodas Labs\'in ("Hizmet Sağlayıcı") Foody uygulaması ve ilişkili web sitelerinde çerezleri ve benzer teknolojileri nasıl kullandığını açıklar.',
      },
      mobile: {
        title: "Mobil uygulamada çerez kullanıyor muyuz?",
        desc: "Uygulama doğrudan tarayıcı çerezleri kullanmaz. Ancak kimlik doğrulama ve oturum yönetimi gibi temel işlevler için yerel depolama veya cihaz tanımlayıcıları kullanabilir.",
      },
      website: {
        title: "Web sitemizde çerezler",
        desc: "Web sitemiz, düzgün çalışmayı sağlamak, tercihleri hatırlamak ve kullanım analizini yapmak için çerezler kullanabilir. Bunlar şunları içerebilir:",
        cookies: [
          "Temel site işlevleri için gerekli zorunlu çerezler.",
          "Ayarlarınızı hatırlayan tercih çerezleri.",
          "Siteyi geliştirmemize yardımcı olan analiz çerezleri.",
        ],
      },
      thirdParty: {
        title: "Üçüncü taraf hizmetler",
        desc: "Analitik veya diğer özellikler için çerez yerleştirebilen üçüncü taraf hizmetler kullanabiliriz. Bu sağlayıcılar web sitesi etkinliğiniz hakkında bilgi toplayabilir.",
      },
      manage: {
        title: "Çerez yönetimi",
        desc: "Çerezleri tarayıcı ayarlarından yönetebilir veya devre dışı bırakabilirsiniz. Çerezleri kapatırsanız bazı site özellikleri düzgün çalışmayabilir.",
      },
      contact: {
        title: "İletişim",
        desc: "Bu Çerez Politikası hakkında sorularınız varsa bize şu adresten ulaşın:",
      },
    },
    foodyTerms: {
      nav: {
        back: "uygulamaya dön",
        privacy: "gizlilik",
        cookie: "çerez",
        terms: "koşullar",
        delete: "silme",
      },
      badge: "kullanım koşulları",
      hero: {
        title: "Foody Uygulaması Kullanım Koşulları",
        desc: "Bu kullanım koşulları, Wodas Labs tarafından freemium hizmet olarak sunulan Foody mobil uygulaması için geçerlidir.",
        effectiveDate: "Yürürlük tarihi: 27 Aralık 2025",
      },
      acceptance: {
        title: "Koşulların kabulü",
        p1: "Uygulamayı indirmeniz veya kullanmanız, bu koşulları kabul ettiğiniz anlamına gelir. Lütfen kullanmadan önce dikkatlice okuyun.",
        p2: "Uygulamanın izinsiz kopyalanması, değiştirilmesi, kaynak kodunun çıkarılması, çevrilmesi veya türev sürümlerinin oluşturulması yasaktır.",
      },
      intellectualProperty: {
        title: "Fikri mülkiyet",
        desc: "Tüm ticari markalar, telif hakları, veri tabanı hakları ve ilgili fikri mülkiyet hakları Hizmet Sağlayıcıya aittir.",
      },
      serviceChanges: {
        title: "Hizmet değişiklikleri ve ücretler",
        desc: "Hizmet Sağlayıcı, uygulamayı değiştirebilir veya hizmetleri ücretlendirebilir. Uygulanan ücretler açık şekilde kullanıcıya bildirilir.",
      },
      deviceSecurity: {
        title: "Cihaz güvenliği sorumluluğu",
        desc: "Telefon güvenliğini ve uygulamaya erişimi korumak sizin sorumluluğunuzdadır. Jailbreak/root işlemleri güvenlik riskleri doğurabilir ve uygulamanın düzgün çalışmasını engelleyebilir.",
      },
      thirdParty: {
        title: "Üçüncü taraf koşulları",
        desc: "Uygulama, kendi kullanım koşulları olan üçüncü taraf hizmetleri kullanır:",
        providers: [
          {
            name: "Google Play Services",
            url: "https://policies.google.com/terms",
          },
          {
            name: "AdMob",
            url: "https://developers.google.com/admob/terms",
          },
          {
            name: "RevenueCat",
            url: "https://www.revenuecat.com/terms",
          },
        ],
      },
      connectivity: {
        title: "Bağlantı ve ücretler",
        p1: "Bazı uygulama işlevleri aktif internet bağlantısı gerektirir. Wi-Fi erişimi olmaması veya veri limitinin bitmesi nedeniyle oluşan kısıtlı kullanımda Hizmet Sağlayıcı sorumlu değildir.",
        p2: "Wi-Fi dışında kullanımda mobil operatörünüzün koşulları ve ücretleri (roaming dahil) geçerli olabilir.",
      },
      liability: {
        title: "Sorumluluk sınırları",
        p1: "Hizmete erişebilmek için cihazınızın şarj durumunu korumak gibi kullanım koşullarından siz sorumlusunuz.",
        p2: "Hizmet Sağlayıcı, uygulama işlevlerine güvenilmesinden kaynaklı doğrudan veya dolaylı zararlardan sorumlu değildir.",
      },
      ai: {
        title: "Yapay zeka teknolojileri",
        desc: "Uygulama, bazı özellikler için AI teknolojileri içerebilir. Uygulamayı kullanarak bunu kabul etmiş olursunuz; AI kullanımı yürürlükteki yasalara uygun şekilde yapılır.",
      },
      updates: {
        title: "Güncellemeler ve sonlandırma",
        desc: "Uygulama herhangi bir zamanda güncellenebilir, değiştirilebilir veya sonlandırılabilir. Hizmet sonlandığında uygulamayı kullanma haklarınız da sona erer.",
      },
      changes: {
        title: "Koşullardaki değişiklikler",
        desc: "Hizmet Sağlayıcı bu kullanım koşullarını dönemsel olarak güncelleyebilir. Lütfen bu sayfayı düzenli olarak kontrol edin.",
      },
      contact: {
        title: "İletişim",
        desc: "Kullanım koşulları hakkında sorularınız veya önerileriniz varsa lütfen şu adrese yazın:",
      },
    },
    foodyDelete: {
      nav: {
        back: "uygulamaya dön",
        privacy: "gizlilik",
        cookie: "çerez",
        terms: "koşullar",
        delete: "silme",
      },
      badge: "hesap silme",
      hero: {
        title: "Hesap silme",
        desc: "Foody hesabınızı ve ilişkili verilerinizi istediğiniz zaman silebilirsiniz.",
      },
      inApp: {
        title: "Seçenek 1 (önerilen): Uygulama içinden silme",
        desc: "Foody uygulamasını açın ve Profil -> Hesabı sil adımına gidin. Onay adımlarını tamamlayın.",
      },
      request: {
        title: "Seçenek 2: E-posta ile silme talebi",
        desc: 'Konu satırına "Foody Account Deletion Request" yazarak support-foody@wodaslabs.com adresine e-posta gönderin ve şunları ekleyin:',
        items: ["Oturum açmak için kullandığınız e-posta adresi"],
        footer: "Silme taleplerini mümkün olan en kısa sürede işleriz.",
      },
      contact: {
        title: "Silme talebi e-postası",
        desc: "Silme talepleri için bu e-posta ve konu satırını kullanın:",
      },
    },
    foodySupport: {
      badge: "destek",
      back: "uygulamaya dön",
      hero: {
        title: "Foody Destek",
        descPrefix: "yardıma mı ihtiyacın var",
        descSuffix:
          "hesap, beslenme, satın alma ve uygulama ile ilgili konularda yardımcı oluyoruz.",
        updatedAt: "Son güncelleme: 31 Mart 2026",
      },
      contact: {
        title: "iletişim",
        emailLabel: "destek e-postası:",
        responseTime: "hedef dönüş süresi: 2 iş günü içinde.",
      },
      contactDetails: {
        title: "bize yazarken",
        subtitle: "daha hızlı destek için şu bilgileri ekleyin:",
        details: [
          "Uygulama sürümü (örnek: 1.0.2)",
          "Cihaz modeli ve işletim sistemi sürümü",
          "Sorunun kısa açıklaması",
          "Mümkünse ekran görüntüsü veya ekran kaydı",
        ],
      },
      commonIssues: {
        title: "yaygın sorunlar",
        items: [
          "Uygulamayı kapatıp yeniden açın.",
          "İnternet bağlantınızı kontrol edin.",
          "Mağazadan en güncel sürüme geçin.",
          "Cihazınızı yeniden başlatın.",
        ],
      },
      links: {
        title: "bağlantılar",
        home: "WodasLabs",
        privacy: "Gizlilik Politikası",
        terms: "Kullanım Koşulları",
        cookie: "Çerez Politikası",
        delete: "Hesap Silme",
      },
      footer: {
        title: "doğrudan yardıma mı ihtiyacın var?",
        desc: "Hukuki veya gizlilikle ilgili konular için şuraya yazın:",
        emailButton: "Desteğe E-posta",
      },
    },
    trains: {
      hero: {
        eyebrow: "trains escape",
        title: "trenleri doğru sırayla çıkar, her bölümü tamamla",
        subtitle:
          "bir trene dokunduğunda lokomotifin baktığı yöne gider. önünde başka tren varsa ekrandan çıkamaz.",
        ctaPrimary: "App Store'da aç",
        ctaSecondary: "Google Play'de bul",
      },
      meta: {
        label: "tren bulmacası",
        platform: "iOS + Android",
        tag: "sıralama + strateji",
        pill: "",
        pillValue: "",
        cta: "indir",
        back: "uygulamalara dön",
      },
      highlights: {
        title: "trains escape'i özel yapan şeyler",
        subtitle:
          "tek dokunuşla oynanan, strateji isteyen net bir bulmaca deneyimi",
        items: [
          {
            title: "tek dokunuşla yönlu hareket",
            desc: "trene dokun ve baktığı yöne doğru kayarak ekrandan çıkmasını sağla.",
          },
          {
            title: "engel mantığına dayalı bölümler",
            desc: "önünde tren olan lokomotif çıkamaz, bu yüzden hamle sırası her şeyi belirler.",
          },
          {
            title: "sade ve akıcı tasarım",
            desc: "minimal görünüm sayesinde dikkat dağılmadan rota ve çözüm planına odaklanırsın.",
          },
        ],
      },
      workflow: {
        title: "bölümler nasıl ilerliyor",
        subtitle: "ekrandaki tüm trenleri çıkar, bölümü geç",
        steps: [
          {
            title: "tahtayı oku",
            desc: "trenlerin yönünü incele ve hangilerinin önünün kapalı olduğunu belirle.",
          },
          {
            title: "doğru sırayı seç",
            desc: "önce yolu açık trenleri çıkararak bloklanan trenler için alan oluştur.",
          },
          {
            title: "bölümü bitir",
            desc: "tüm trenler güvenle ekrandan çıkınca bölüm tamamlanır.",
          },
        ],
      },
      personas: {
        title: "bulmaca severler için tasarlandı",
        subtitle: "rahatlatan tempo, güçlü strateji hissi",
        items: [
          "mantık bulmacası oyuncuları",
          "kısa molada oyun oynayanlar",
          "strateji ve planlama sevenler",
        ],
        note: "değişen yerleşimler ve artan zorluk her bölümü yeni bir meydan okumaya dönüştürür.",
      },
      cta: {
        title: "tüm trenleri güvenle çıkarabilecek misin?",
        desc: "rayları kontrol et, çarpısmaları önle ve daha akıllı bölümleri çözmeye başla.",
        primary: "App Store'a git",
        secondary: "Google Play'e git",
      },
    },
    trainsSupport: {
      badge: "destek",
      back: "uygulamaya dön",
      hero: {
        title: "Trains Escape Destek",
        descPrefix: "yardıma mı ihtiyacın var",
        descSuffix:
          "oyun içi sorunlar, hatalar, satın alma problemleri ve hesap/cihaz konularında yardımcı oluyoruz.",
        updatedAt: "Son güncelleme: 29 Mart 2026",
      },
      contact: {
        title: "iletişim",
        emailLabel: "destek e-postası:",
        responseTime: "hedef dönüş süresi: 2 iş günü içinde.",
      },
      contactDetails: {
        title: "bize yazarken",
        subtitle: "daha hızlı destek için şu bilgileri ekleyin:",
        details: [
          "Uygulama sürümü (örnek: 1.0.2)",
          "Cihaz modeli ve iOS sürümü",
          "Sorunun kısa açıklaması",
          "Mümkünse ekran görüntüsü veya ekran kaydı",
        ],
      },
      commonIssues: {
        title: "yaygın sorunlar",
        items: [
          "Uygulamayı kapatıp yeniden açın.",
          "İnternet bağlantınızı kontrol edin.",
          "App Store'dan en güncel sürüme geçin.",
          "Cihazınızı yeniden başlatın.",
        ],
      },
      links: {
        title: "bağlantılar",
        home: "WodasLabs",
        privacy: "Gizlilik Politikası",
        terms: "Kullanım Koşulları",
      },
      footer: {
        title: "doğrudan yardıma mı ihtiyacın var?",
        desc: "Hukuki veya gizlilikle ilgili konular için şuraya yazın:",
        emailButton: "Desteğe E-posta",
      },
    },
    trainsPrivacy: {
      nav: {
        back: "uygulamaya dön",
        support: "destek",
        terms: "koşullar",
      },
      badge: "gizlilik politikası",
      hero: {
        title: "Trains Escape Gizlilik Politikası",
        desc: 'Bu gizlilik politikası, Wodas Labs tarafından freemium hizmet olarak sunulan Trains Escape mobil uygulaması için geçerlidir ve hizmet "OLDUĞU GİBİ" sağlanır.',
        effectiveDate: "Yürürlük tarihi: 15 Mart 2026",
      },
      collection: {
        title: "Bilgi Toplama ve Kullanım",
        desc: "Uygulama indirildiğinde ve kullanıldığında bazı bilgiler toplanabilir:",
        items: [
          "Cihazınızın IP adresi",
          "Ziyaret edilen sayfalar, ziyaret tarihi/saati ve geçirilen süre",
          "Uygulamada geçirilen toplam süre",
          "Mobil cihazınızın işletim sistemi bilgisi",
        ],
        noLocation: "Uygulama, cihazınızın hassas konum bilgilerini toplamaz.",
        noAi: "Uygulama, verilerinizi işlemek veya özellik sunmak için Yapay Zeka (AI) teknolojileri kullanmaz.",
      },
      personal: {
        title: "Kişisel Veri ve İletişim",
        p1: "Daha iyi deneyim için Hizmet Sağlayıcı; cihaz bilgisi, reklam tanımlayıcı ve satın alma bilgisi gibi kişisel veriler talep edebilir.",
        p2: "Sağlanan bilgiler önemli bildirimler, zorunlu duyurular ve pazarlama bilgilendirmeleri için kullanılabilir.",
      },
      thirdParty: {
        title: "Üçüncü Taraf Erişimi",
        p1: "Uygulamayı ve hizmet kalitesini geliştirmek amacıyla, yalnızca toplu ve anonimleştirilmiş veriler belirli aralıklarla üçüncü taraf hizmetlere aktarılabilir.",
        p2: "Uygulamanın kullandığı üçüncü taraf hizmetler:",
        providers: [
          {
            name: "Google Play Services",
            url: "https://www.google.com/policies/privacy/",
          },
          {
            name: "AdMob",
            url: "https://support.google.com/admob/answer/6128543?hl=en",
          },
          {
            name: "RevenueCat",
            url: "https://www.revenuecat.com/privacy",
          },
        ],
      },
      disclosure: {
        title: "Bilgi Paylaşım Durumları",
        desc: "Hizmet Sağlayıcı, yasal zorunluluk, hak ve güvenliğin korunması, dolandırıcılık incelemesi veya gizlilik yükümlülüğü altındaki güvenilir hizmet sağlayıcılarla çalışma durumlarında bilgi paylaşabilir.",
      },
      optOut: {
        title: "Vazgeçme Hakları",
        desc: "Bilgi toplanmasını durdurmak için uygulamayı cihazınızdan veya uygulama mağazasından standart yöntemlerle kaldırabilirsiniz.",
      },
      retention: {
        title: "Veri Saklama",
        desc: "Kullanıcı tarafından sağlanan veriler, uygulamayı kullandığınız süre boyunca ve sonrasında makul bir süre saklanır.",
        contactLabel: "Veri silme talepleri için iletişim:",
      },
      children: {
        title: "Çocuklar",
        p1: "Uygulama, 13 yaş altındaki çocuklardan bilerek kişisel veri toplamayı hedeflemez.",
        p2: "Bu tür veri tespit edilirse derhal silinir. Ebeveynler veya vasiler support-trainsescape@wodaslabs.com adresinden iletişime geçebilir.",
      },
      security: {
        title: "Güvenlik ve Değişiklikler",
        p1: "Hizmet Sağlayıcı, işlenen ve saklanan veriler için fiziksel, elektronik ve prosedürel güvenlik önlemleri uygular.",
        p2: "Bu politika güncellenebilir. Uygulamayı kullanmaya devam etmeniz güncel koşulları kabul ettiğiniz anlamına gelir.",
      },
      contact: {
        title: "İletişim",
        desc: "Uygulamayı kullanırken gizlilikle ilgili sorularınız varsa lütfen şu adrese yazın:",
        cta: "desteği aç",
      },
    },
    trainsTerms: {
      nav: {
        back: "uygulamaya dön",
        support: "destek",
      },
      badge: "kullanım koşulları",
      hero: {
        title: "Trains Escape Kullanım Koşulları",
        desc: "Bu koşullar, Wodas Labs tarafından freemium hizmet olarak sunulan Trains Escape mobil uygulaması için geçerlidir.",
        effectiveDate: "Yürürlük tarihi: 15 Mart 2026",
      },
      acceptance: {
        title: "Koşulların Kabulü",
        p1: "Uygulamayı indirerek veya kullanarak bu koşulları otomatik olarak kabul etmiş olursunuz. Lütfen kullanmadan önce dikkatlice okuyun.",
        p2: "Uygulamanın izinsiz kopyalanması, değiştirilmesi, kaynak kodunun çıkarılması, çevrilmesi veya türevlerinin oluşturulması yasaktır.",
      },
      intellectualProperty: {
        title: "Fikri Mülkiyet",
        desc: "Uygulamaya ilişkin tüm ticari marka, telif hakkı, veri tabanı ve diğer fikri mülkiyet hakları Hizmet Sağlayıcıya aittir.",
      },
      serviceChanges: {
        title: "Hizmet Değişiklikleri ve Ücretler",
        desc: "Hizmet Sağlayıcı uygulamayı değiştirebilir veya hizmetleri ücretlendirebilir. Olası ücretler açık şekilde kullanıcıya bildirilir.",
      },
      deviceSecurity: {
        title: "Cihaz Güvenliği Sorumluluğu",
        desc: "Cihaz güvenliğini korumak kullanıcının sorumluluğundadır. Jailbreak/root işlemleri güvenlik riskleri doğurabilir ve uygulamanın düzgün çalışmasını engelleyebilir.",
      },
      thirdParty: {
        title: "Üçüncü Taraf Koşulları",
        desc: "Uygulama, kendi kullanım koşulları olan üçüncü taraf hizmetleri kullanır:",
        providers: [
          {
            name: "Google Play Services",
            url: "https://policies.google.com/terms",
          },
          {
            name: "AdMob",
            url: "https://developers.google.com/admob/terms",
          },
          {
            name: "RevenueCat",
            url: "https://www.revenuecat.com/terms",
          },
        ],
      },
      connectivity: {
        title: "Bağlantı ve Veri Ücretleri",
        p1: "Bazı özellikler aktif internet bağlantısı gerektirir. Bağlantı sorunları veya veri limitinin dolması nedeniyle oluşan kısıtlı kullanımda Hizmet Sağlayıcı sorumlu değildir.",
        p2: "Wi-Fi dışında kullanımda mobil operatörünüzün koşulları ve ücretleri (roaming dahil) geçerli olabilir.",
      },
      liability: {
        title: "Sorumluluk Sınırları",
        p1: "Hizmet Sağlayıcı cihazın pil durumu gibi kullanıcı taraflı koşullardan veya kesintisiz erişimden her zaman sorumlu tutulamaz.",
        p2: "Uygulama işlevlerine dayanarak oluşabilecek doğrudan veya dolaylı zararlardan Hizmet Sağlayıcı sorumluluk kabul etmez.",
      },
      updates: {
        title: "Güncellemeler ve Sonlandırma",
        desc: "Uygulama her zaman güncellenmeyebilir, değiştirilebilir veya sonlandırılabilir. Hizmet sonlandığında uygulamayı kullanma hakları da sona erer.",
      },
      changes: {
        title: "Koşullardaki Değişiklikler",
        desc: "Hizmet Sağlayıcı bu koşulları dönemsel olarak güncelleyebilir. Değişiklikler için sayfayı düzenli kontrol etmeniz önerilir.",
      },
      contact: {
        title: "İletişim",
        desc: "Kullanım koşulları hakkında sorularınız veya önerileriniz varsa lütfen şu adrese yazın:",
        cta: "desteği aç",
      },
    },
    orbis: {
      hero: {
        eyebrow: "Orbis Lines",
        title: "renkli çizgiler kur, 9x9 tahtayı canlı tut",
        subtitle:
          "topları tahtada hareket ettir, aynı renkten 5 veya daha fazla topu hizala ve yeni toplar için yeterli boş alan bırak.",
        ctaPrimary: "App Store'da aç",
        ctaSecondary: "Google Play'de bul",
      },
      meta: {
        label: "klasik lines bulmacası",
        platform: "iOS + Android",
        tag: "renk stratejisi",
        pill: "",
        pillValue: "",
        cta: "indir",
        back: "uygulamalara dön",
      },
      highlights: {
        title: "mobilde klasik lines stratejisi",
        subtitle:
          "basit hamleler, net yol planlama ve hızlı skor kararları",
        items: [
          {
            title: "9x9 tahta taktiği",
            desc: "topları doğru konuma taşırken sonraki hamleler için açık yolları koru.",
          },
          {
            title: "yola bağlı hareket",
            desc: "bir top yalnızca bulunduğu hücreden hedef hücreye boş bir yol varsa hareket edebilir.",
          },
          {
            title: "yatay, dikey ve çapraz temizleme",
            desc: "tahta dolmadan önce her yönde aynı renkli çizgiler oluştur ve topları temizle.",
          },
        ],
      },
      workflow: {
        title: "nasıl oynanır",
        subtitle:
          "tahta dolmadan aynı renkten 5 veya daha fazla top içeren çizgileri temizle",
        steps: [
          {
            title: "bir top seç",
            desc: "bir topu seç ve boş yol varsa boş bir hedef hücreye taşı.",
          },
          {
            title: "çizgi oluştur",
            desc: "aynı renkten 5 veya daha fazla topu yatay, dikey ya da çapraz hizala.",
          },
          {
            title: "yeni topları yönet",
            desc: "her hamleden sonra çizgi temizlenmezse tahtaya yeni toplar gelir.",
          },
          {
            title: "dolu tahtada hayatta kal",
            desc: "tahta tamamen dolup yapılacak hamle kalmadığında oyun biter.",
          },
        ],
      },
      scoring: {
        title: "puanlama",
        subtitle: "daha fazla top ve yön temizleyerek puanı büyüt",
        items: [
          "5 top = 5 puan",
          "6 top = 6 puan, böyle devam eder",
          "tek hamlede 2 yön = x2",
          "tek hamlede 3 yön = x3",
          "tek hamlede 4 yön = x5",
        ],
        note: "en iyi skorlar anonim olarak saklanır, böylece oyuncular ilerlemelerini takip edebilir.",
      },
      cta: {
        title: "tahtayı açık tutmaya hazır mısın?",
        desc: "temiz hamleler yap, güçlü çizgiler kur ve daha yüksek skoru kovala.",
        primary: "App Store'a git",
        secondary: "Google Play'e git",
      },
    },
    orbisSupport: {
      badge: "destek",
      back: "uygulamaya dön",
      hero: {
        title: "Orbis Lines Destek",
        descPrefix: "yardıma mı ihtiyacın var",
        descSuffix:
          "oyun içi sorunlar, hatalar, reklamlar, skorlar ve cihaz konularında yardımcı oluyoruz.",
        updatedAt: "Son güncelleme: 2 Mayıs 2026",
      },
      contact: {
        title: "iletişim",
        emailLabel: "destek e-postası:",
        responseTime: "hedef dönüş süresi: 2 iş günü içinde.",
      },
      contactDetails: {
        title: "bize yazarken",
        subtitle: "daha hızlı destek için şu bilgileri ekleyin:",
        details: [
          "Uygulama sürümü (örnek: 1.0.0)",
          "Cihaz modeli ve işletim sistemi sürümü",
          "Sorunun kısa açıklaması",
          "Mümkünse ekran görüntüsü veya ekran kaydı",
        ],
      },
      commonIssues: {
        title: "yaygın sorunlar",
        items: [
          "Uygulamayı kapatıp yeniden açın.",
          "İnternet bağlantınızı kontrol edin.",
          "Mağazadan en güncel sürüme geçin.",
          "Cihazınızı yeniden başlatın.",
        ],
      },
      links: {
        title: "bağlantılar",
        home: "WodasLabs",
        privacy: "Gizlilik Politikası",
        terms: "Kullanım Koşulları",
      },
      footer: {
        title: "doğrudan yardıma mı ihtiyacın var?",
        desc: "Hukuki veya gizlilikle ilgili konular için şuraya yazın:",
        emailButton: "Desteğe E-posta",
      },
    },
    orbisPrivacy: {
      nav: {
        back: "uygulamaya dön",
        support: "destek",
        terms: "koşullar",
      },
      badge: "gizlilik politikası",
      hero: {
        title: "Orbis Lines Gizlilik Politikası",
        desc: 'Bu gizlilik politikası, Wodas Labs tarafından freemium hizmet olarak sunulan Orbis Lines mobil uygulaması için geçerlidir ve hizmet "OLDUĞU GİBİ" sağlanır.',
        effectiveDate: "Yürürlük tarihi: 2 Mayıs 2026",
      },
      collection: {
        title: "Bilgi Toplama ve Kullanım",
        desc: "Uygulama indirildiğinde ve kullanıldığında sınırlı teknik ve oyun bilgileri toplanabilir. Bunlar şunları içerebilir:",
        items: [
          "Skor özellikleri için gereken anonim en iyi skor ve oyun ilerleme bilgisi",
          "Firebase üzerinden alınan force update, reklam konfigürasyonu ve özellik ayarları gibi app config değerleri",
          "Cihaz tipi, işletim sistemi sürümü, uygulama sürümü ve temel tanılama bilgileri",
          "Uygulamada reklam gösteriliyorsa reklamla ilişkili sinyaller",
        ],
        noPersonal:
          "Uygulama hesap gerektirmez ve skor özellikleri için ad, e-posta, telefon numarası veya doğrudan kimlik belirleyen kişisel bilgileri bilerek saklamaz.",
        noLocation: "Uygulama, cihazınızın hassas konum bilgilerini toplamaz.",
        noAi: "Uygulama, verilerinizi işlemek veya özellik sunmak için Yapay Zeka (AI) teknolojileri kullanmaz.",
      },
      firebase: {
        title: "Firebase ve Anonim Skorlar",
        p1: "Orbis Lines, anonim en iyi skorları ve app config değerlerini saklamak için Firebase kullanır. Bu kayıtlar skor özelliklerini çalıştırmak, force update akışlarını desteklemek ve uygulama ya da reklam ayarlarını yönetmek için kullanılır.",
        p2: "En iyi skor verisi kişisel bir profile bağlı değildir. Oyun kayıtlarını kaydetmek veya geri almak için yalnızca gerektiğinde anonim ya da oluşturulmuş tanımlayıcılar kullanılabilir.",
      },
      thirdParty: {
        title: "Üçüncü Taraf Erişimi",
        p1: "Uygulamayı işletmek, güvenliğini sağlamak ve geliştirmek için yalnızca sınırlı, toplu veya anonim veriler dış servislere aktarılabilir.",
        p2: "Uygulamanın kullandığı üçüncü taraf hizmetler şunları içerebilir:",
        providers: [
          {
            name: "Google Play Services",
            url: "https://www.google.com/policies/privacy/",
          },
          {
            name: "Firebase",
            url: "https://firebase.google.com/support/privacy",
          },
          {
            name: "AdMob",
            url: "https://support.google.com/admob/answer/6128543?hl=en",
          },
        ],
      },
      disclosure: {
        title: "Bilgi Paylaşım Durumları",
        desc: "Hizmet Sağlayıcı, yasal zorunluluk, hak ve güvenliğin korunması, dolandırıcılık veya kötüye kullanım incelemesi ya da gizlilik yükümlülüğü altındaki güvenilir hizmet sağlayıcılarla çalışma durumlarında bilgi paylaşabilir.",
      },
      optOut: {
        title: "Vazgeçme Hakları",
        desc: "Bilgi toplanmasını durdurmak için uygulamayı cihazınızdan veya uygulama mağazasından standart yöntemlerle kaldırabilirsiniz.",
      },
      retention: {
        title: "Veri Saklama",
        desc: "Anonim skor ve konfigürasyonla ilişkili kayıtlar, Uygulamayı sunmak ve geliştirmek için gerekli olduğu sürece saklanır. Toplu tanılama bilgileri hizmet kalitesi ve kötüye kullanım önleme için tutulabilir.",
        contactLabel: "Silme veya gizlilik talepleri için iletişim:",
      },
      children: {
        title: "Çocuklar",
        p1: "Uygulama, 13 yaş altındaki çocuklardan bilerek kişisel veri toplamayı hedeflemez.",
        p2: "Bu tür veri tespit edilirse derhal silinir. Ebeveynler veya vasiler support-orbislines@wodaslabs.com adresinden iletişime geçebilir.",
      },
      security: {
        title: "Güvenlik ve Değişiklikler",
        p1: "Hizmet Sağlayıcı, işlenen ve saklanan veriler için fiziksel, elektronik ve prosedürel güvenlik önlemleri uygular.",
        p2: "Bu politika güncellenebilir. Uygulamayı kullanmaya devam etmeniz güncel koşulları kabul ettiğiniz anlamına gelir.",
      },
      contact: {
        title: "İletişim",
        desc: "Uygulamayı kullanırken gizlilikle ilgili sorularınız varsa lütfen şu adrese yazın:",
        cta: "desteği aç",
      },
    },
    orbisTerms: {
      nav: {
        back: "uygulamaya dön",
        support: "destek",
      },
      badge: "kullanım koşulları",
      hero: {
        title: "Orbis Lines Kullanım Koşulları",
        desc: "Bu koşullar, Wodas Labs tarafından freemium hizmet olarak sunulan Orbis Lines mobil uygulaması için geçerlidir.",
        effectiveDate: "Yürürlük tarihi: 2 Mayıs 2026",
      },
      acceptance: {
        title: "Koşulların Kabulü",
        p1: "Uygulamayı indirerek veya kullanarak bu koşulları otomatik olarak kabul etmiş olursunuz. Lütfen kullanmadan önce dikkatlice okuyun.",
        p2: "Uygulamanın izinsiz kopyalanması, değiştirilmesi, kaynak kodunun çıkarılması, çevrilmesi veya türevlerinin oluşturulması yasaktır.",
      },
      gameplay: {
        title: "Oynanış ve Skorlar",
        desc: "Orbis Lines eğlence amacıyla sunulur. Skorlar, en iyi skorlar, reklam uygunluğu, force update davranışı ve oyun konfigürasyonu yerel cihaz durumuna veya uzak konfigürasyon servislerine bağlı olabilir.",
      },
      intellectualProperty: {
        title: "Fikri Mülkiyet",
        desc: "Uygulamaya ilişkin tüm ticari marka, telif hakkı, veri tabanı ve diğer fikri mülkiyet hakları Hizmet Sağlayıcıya aittir.",
      },
      serviceChanges: {
        title: "Hizmet Değişiklikleri ve Ücretler",
        desc: "Hizmet Sağlayıcı uygulamayı değiştirebilir, app config ayarlarını güncelleyebilir, reklam davranışını değiştirebilir veya hizmetleri ücretlendirebilir. Olası ücretler açık şekilde kullanıcıya bildirilir.",
      },
      deviceSecurity: {
        title: "Cihaz Güvenliği Sorumluluğu",
        desc: "Cihaz güvenliğini korumak kullanıcının sorumluluğundadır. Jailbreak/root işlemleri güvenlik riskleri doğurabilir ve uygulamanın düzgün çalışmasını engelleyebilir.",
      },
      thirdParty: {
        title: "Üçüncü Taraf Koşulları",
        desc: "Uygulama, kendi kullanım koşulları olan üçüncü taraf hizmetleri kullanır:",
        providers: [
          {
            name: "Google Play Services",
            url: "https://policies.google.com/terms",
          },
          {
            name: "Firebase",
            url: "https://firebase.google.com/terms",
          },
          {
            name: "AdMob",
            url: "https://developers.google.com/admob/terms",
          },
        ],
      },
      connectivity: {
        title: "Bağlantı ve Veri Ücretleri",
        p1: "Uzak konfigürasyon, reklamlar, force update kontrolleri, tanılama ve skorla ilişkili özellikler dahil bazı işlevler aktif internet bağlantısı gerektirebilir.",
        p2: "Wi-Fi dışında kullanımda mobil operatörünüzün koşulları ve ücretleri (roaming dahil) geçerli olabilir.",
      },
      liability: {
        title: "Sorumluluk Sınırları",
        p1: "Hizmet Sağlayıcı cihaz durumu, ağ bağlantısı, kesintili erişim, skor senkronizasyon sorunları veya üçüncü taraf servislerin erişilebilirliğinden her zaman sorumlu tutulamaz.",
        p2: "Uygulama işlevlerine dayanarak oluşabilecek doğrudan veya dolaylı zararlardan Hizmet Sağlayıcı sorumluluk kabul etmez.",
      },
      updates: {
        title: "Güncellemeler ve Sonlandırma",
        desc: "Uygulama herhangi bir zamanda güncellenebilir, değiştirilebilir, force update gerektirebilir veya sonlandırılabilir. Hizmet sonlandığında uygulamayı kullanma hakları da sona erer.",
      },
      changes: {
        title: "Koşullardaki Değişiklikler",
        desc: "Hizmet Sağlayıcı bu koşulları dönemsel olarak güncelleyebilir. Değişiklikler için sayfayı düzenli kontrol etmeniz önerilir.",
      },
      contact: {
        title: "İletişim",
        desc: "Kullanım koşulları hakkında sorularınız veya önerileriniz varsa lütfen şu adrese yazın:",
        cta: "desteği aç",
      },
    },
  },
};

export default translations;
